let initPromise;

/**
 * Loads PostHog and initializes it for anonymous tracking.
 */
export function initPosthog(config) {
  initPromise = import("posthog-js").then((posthog) => {
    return posthog.default.init(config.apiKey, {
      api_host: config.reverseProxy || "https://eu.i.posthog.com",
      ui_host: "https://eu.posthog.com",
      defaults: "2025-11-30",
      cross_subdomain_cookie: true,
      disable_session_recording: true,
      session_recording: {
        recordCrossOriginIframes: true,
        maskAllInputs: true,
        maskInputFn: (text, element) => {
          if (element?.type === "password") return "*".repeat(text.length);
          if (element?.closest?.("[data-posthog-unmask]")) return text;
          return "*".repeat(text.length);
        },
      },
      before_send: (event) => {
        delete event?.properties.$ip;
        return event;
      },
    });
  });
}

export function startPosthogSessionRecording() {
  initPromise?.then((instance) => {
    instance.startSessionRecording({ url_trigger: true });
  });
}

/**
 * Identifies the user with PostHog and applies the license-based opt-in/out gate.
 */
export function identifyPosthogUser(user, license = {}) {
  initPromise?.then((instance) => {
    if (!license?.tracking) {
      instance.opt_out_capturing();
      return;
    }
    // Opt-in state is saved in browser; switching companies requires intentional re-opt-in.
    instance.opt_in_capturing();

    const { company, role } = user;
    const { type, plan } = license;
    instance.identify(user.id, { company, role, type, plan });
    instance.group("company", company, { id: company });
  });
}
